module.exports = __webpack_public_path__ + "img/8.4b9867ff.jpg";